import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MyApColorTheme } from '@app/shared/enums';
import { CommonModalDialogOption, ModalDialogButtonType, ModalDialogResult } from './common-modal-dialog.constant';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LineSeparatorStyle } from '@shared/components/line-separator/line-separator.constant';
import { LineSeparatorComponent } from '../line-separator/line-separator.component';

@Component({
  selector: 'app-common-modal-dialog',
  templateUrl: './common-modal-dialog.component.html',
  styleUrls: ['./common-modal-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TranslateModule, LineSeparatorComponent, MatDialogModule]
})
export class CommonModalDialogComponent implements OnInit {
  showHeader: boolean = false;
  title: string = "";
  isErrorMessage: boolean = false;
  btnType: ModalDialogButtonType = ModalDialogButtonType.CLOSE;
  btnTypeEnum: typeof ModalDialogButtonType = ModalDialogButtonType;
  LineSeparatorStyle: typeof LineSeparatorStyle = LineSeparatorStyle;
  ColorTheme: typeof MyApColorTheme = MyApColorTheme;


  constructor(public dialogRef: MatDialogRef<CommonModalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CommonModalDialogOption) {
    this.btnType = data.buttonType ?? this.btnType;
    this.showHeader = data.header ?? this.showHeader;
    this.title = data.title ?? this.title;
    this.isErrorMessage = data.isErrorMessage ?? this.isErrorMessage;
  }

  ngOnInit(): void {
  }

  onYesClick = () => this.dialogRef.close({ data: ModalDialogResult.YES });

  onNoClick = () => this.dialogRef.close({ data: ModalDialogResult.NO });

  onOkClick = () => this.dialogRef.close({ data: ModalDialogResult.OK });

  onCancelClick = () => this.dialogRef.close({ data: ModalDialogResult.CANCEL });

  onCloseClick = () => this.dialogRef.close({ data: ModalDialogResult.CLOSE });
}
